export default __webpack_public_path__ + "static/media/event2.dcac46b3.png";